//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  ClientRetailersResponse,
  GetClientRetailersResponse,
} from '@apis/campaign-requests/sampling/retailers/samplingRetailersApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const RETAILERS_DEFAULT_ENDPOINT = '/api/v1/retailers';

const retailersFetch = (
  endpoint: string,
  init?: RequestInit,
  useFetchHeader?: boolean,
): Promise<ISerializedResponse> =>
  serializedGatewayFetch(
    'sampling_gateway',
    `${RETAILERS_DEFAULT_ENDPOINT}${endpoint}`,
    init,
    useFetchHeader,
  );

/**
 * Gets retailers for a client.
 *
 * GET /api/v1/retailers
 */
export const getClientRetailers = async (
  init?: RequestInit,
): Promise<GetClientRetailersResponse> => {
  const res = await retailersFetch('', {
    ...init,
    method: 'GET',
  });

  const getClientRetailersResponse = await res.json<ClientRetailersResponse>();

  return getClientRetailersResponse.data;
};
